import { Dot } from 'lucide-react'
import React from 'react'

const StatusBadge = ({ status }) => {

    if (['Active', 'Approved', 'Success', 1].includes(status)) {
        return (
            <span className="text-green-600 flex justify-start items-center rounded-3xl text-center bg-green-200  w-fit px-2 font-sm">
                <span>{status == 1 ? 'Active' : status}</span>
            </span>
        )
    }
    if (['On Hold', 'Pending'].includes(status)) {
        return (
            <span className="text-yellow-500 flex justify-start items-center rounded-3xl text-center bg-yellow-200  w-fit px-2 font-sm">
                <span>{status}</span>
            </span>
        )
    }
    if (['Inactive', 'Yet To Generate', 0].includes(status)) {
        return (
            <span className="text-gray-600 flex justify-start items-center rounded-3xl text-center bg-gray-200  w-fit px-2 font-sm">
                <span>{status == 0 ? 'Inactive' : status}</span>
            </span>
        )
    }

    if (['Partial Success'].includes(status)) {
        return (
            <span className="text-lime-600 flex justify-start items-center rounded-3xl text-center bg-lime-200  w-fit px-2 font-sm">
                <span>{status}</span>
            </span>
        )
    }
    if (['Error'].includes(status)) {
        return (
            <span className="text-red-600 flex justify-start items-center rounded-3xl text-center bg-red-200  w-fit px-2 font-sm">
                <span>{status}</span>
            </span>
        )
    }
}

export default StatusBadge
